import type { HistoricoCaixaModel } from "../models/historicoCaixaModel"
import { HistoricoCaixaInicial } from "../models/historicoCaixaModel"
import { HistoricoCaixaActionsTypes } from "./historicoCaixaActions"
import type { HistoricoCaixaActions } from "./historicoCaixaActions"

export function historicoCaixaReducer(
    state: HistoricoCaixaModel = HistoricoCaixaInicial,
    action: HistoricoCaixaActions
): HistoricoCaixaModel {
    switch (action.type) {
        case HistoricoCaixaActionsTypes.CARREGAR:
            return { ...state, caixas: action.payload }
        default:
            return state
    }
}
